import {
  DARK,
  LEFT,
  LIGHT,
  REPAIRED_FILTER_TYPE,
  SIDE_MENU_CLOSE_Z_INDEX,
  GENDER_FILTER_TYPE,
  AGE_GROUP_FILTER_TYPE,
  CONDITION_FILTER_TYPE,
  BRAND_FILTER_TYPE,
  CATEGORY_FILTER_TYPE,
} from "../core/constants";

import Box from "./Box";
import ButtonPrimary from "./ButtonPrimary";
import CategoryFilters from "./CategoryFilters";
import CloseButton from "./CloseButton";
import ConditionToggle from "./ConditionToggle";
import DropdownFilterWidget from "./DropdownFilterWidget";
import FilterMenuSection from "./FilterMenuSection";
import Line from "./Line";
import React from "react";
import SideMenu from "./SideMenu";
import Text from "./Text";
import { useAppContext } from "./AppContext";
import { useListingsContext } from "./ListingsContext";
import {
  getAvailableFiltersOfType,
  getConditionFiltersInOrder,
} from "../core/utils";
import RepairedFilter from "./RepairedFilter";

function FilterMenu({ rootCategory }) {
  const { filterMenuOpen, setFilterMenuOpen } = useAppContext();
  const {
    availableFilters,
    clearAllFilters,
    showGenderFilter,
    showCategoryFilter,
    isBrandContext,
    showCategoryLinks,
    activeFilters,
  } = useListingsContext();

  const genderFilter = getAvailableFiltersOfType(
    availableFilters,
    GENDER_FILTER_TYPE
  );
  const ageGroupFilter = getAvailableFiltersOfType(
    availableFilters,
    AGE_GROUP_FILTER_TYPE
  );
  const categoryFilter = getAvailableFiltersOfType(
    availableFilters,
    CATEGORY_FILTER_TYPE
  );

  const [brandNew, asNew, preLoved] =
    getConditionFiltersInOrder(availableFilters);

  const repairedFilter = getAvailableFiltersOfType(
    availableFilters,
    REPAIRED_FILTER_TYPE
  );

  const otherFilters = availableFilters.filter((filter) => {
    const filtersToHide = [
      GENDER_FILTER_TYPE,
      CONDITION_FILTER_TYPE,
      REPAIRED_FILTER_TYPE,
      AGE_GROUP_FILTER_TYPE,
      CATEGORY_FILTER_TYPE,
    ];
    if (isBrandContext) {
      filtersToHide.push(BRAND_FILTER_TYPE);
    }
    return !filtersToHide.includes(filter.type);
  });

  return (
    <SideMenu
      open={filterMenuOpen}
      setOpen={setFilterMenuOpen}
      theme={LIGHT}
      startPos={LEFT}
    >
      <Box
        bg="white"
        position="absolute"
        width="100%"
        top={0}
        px={[15, "4.76vw", null, null]}
        pt={50}
        display="flex"
        justifyContent="flex-end"
        zIndex={SIDE_MENU_CLOSE_Z_INDEX}
      >
        <CloseButton
          theme={DARK}
          onClick={() => {
            setFilterMenuOpen(false);
          }}
        />
      </Box>
      <Box
        pt={[70, null, 100, null]}
        pb={[100, null, 130, null]}
        px={[15, "4.76vw", null, null]}
      >
        {activeFilters && (
          <>
            <FilterMenuSection>
              <Text uppercase fontWeight={700} fontSize={[14, 14, 16, 16]}>
                Filter
              </Text>
              <ButtonPrimary theme={DARK} onClick={clearAllFilters}>
                Clear filters
              </ButtonPrimary>
            </FilterMenuSection>
            <Line />
            {typeof brandNew !== "undefined" && (
              <Box key={brandNew.label} display={[null, null, "none", null]}>
                <Box py={[20, null, 30, null]}>
                  <ConditionToggle option={brandNew} />
                </Box>
                <Line />
              </Box>
            )}
            {typeof asNew !== "undefined" && (
              <Box key={asNew.label} display={[null, null, "none", null]}>
                <Box py={[20, null, 30, null]}>
                  <ConditionToggle option={asNew} />
                </Box>
                <Line />
              </Box>
            )}
            {typeof preLoved !== "undefined" && (
              <Box key={preLoved.label} display={[null, null, "none", null]}>
                <Box py={[20, null, 30, null]}>
                  <ConditionToggle option={preLoved} />
                </Box>
                <Line />
              </Box>
            )}
            {typeof repairedFilter !== "undefined" && (
              <Box display={[null, null, "none", null]}>
                <Box py={[20, null, null, null]}>
                  <RepairedFilter />
                </Box>
                <Line />
              </Box>
            )}

            {showCategoryLinks && (
              <>
                <CategoryFilters
                  isBrandContext={isBrandContext}
                  rootCategory={rootCategory}
                />
                <Line />
              </>
            )}
            {showCategoryFilter &&
              typeof categoryFilter !== "undefined" &&
              categoryFilter.options.length > 0 && (
                <DropdownFilterWidget filter={categoryFilter} />
              )}

            {showGenderFilter &&
              typeof genderFilter !== "undefined" &&
              genderFilter.options.length > 0 && (
                <DropdownFilterWidget filter={genderFilter} />
              )}
            {typeof ageGroupFilter !== "undefined" &&
              ageGroupFilter.options.length > 0 && (
                <DropdownFilterWidget filter={ageGroupFilter} />
              )}

            {otherFilters.map((filter) => {
              if (filter.options.length > 0) {
                return (
                  <DropdownFilterWidget key={filter.type} filter={filter} />
                );
              }
            })}
          </>
        )}
      </Box>
    </SideMenu>
  );
}

export default FilterMenu;
